module.exports = __webpack_public_path__ + "img/cn-bg-hero.00c9296.png";